

export const defaultState = (state, getDefaultValue) => {
    if (state.value != null) {
        return state;
    } else {
        return {
            ...state,
            value: getDefaultValue(),
        };
    }
};